var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"color-module__tabs"},[_c('div',{staticClass:"color-module__title-wrap"},[_c('span',{staticClass:"color-module__title title--search"},[_vm._v(_vm._s(_setup.colorModuleTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }